import React from 'react'
import { useAppDispatch } from '../../../store/hooks'
import { logout } from '../../../store/auth/authSlice'
import { handleCompanySsoLogout } from '../../../common/companySso'
import { Button } from '../../../components/Button/Button'

interface OAuthUserBarProps {
  userName: string
}

export const OAuthUserBar: React.FC<OAuthUserBarProps> = ({ userName }) => {
  const dispatch = useAppDispatch()

  const handleSignOut = () => {
    handleCompanySsoLogout()
    dispatch(logout({}))
    window.location.href = '/login'
  }

  return (
    <div className='oauth-user-bar d-flex align-items-center justify-content-center gap-2 w-100 mb-5'>
      <span className='text-body'>
        Signed in as <strong>{userName}</strong>
      </span>
      <span className='text-body'>Not you?</span>
      <Button variant='link' onClick={handleSignOut} className='p-0 text-body text-decoration-underline fw-bold oauth-btn-sm'>
        Sign out
      </Button>
    </div>
  )
}
